import { ImeSeriousnessControllerApi, type ImeSeriousnessPreview } from "@/lib/api/generated/casedb";
import { catalogApiClient } from "../../shared/services/catalogApiClient";
import type { ImeTarget } from "../model/imeSeriousness";

/**
 * What the EMA IME list gives one event's preferred term (PT): for a PT on the list only Medically Significant and the
 * sentence, for a PT that is not on it no criterion and empty notes, and nothing when there is no PT. A lower level
 * term is checked by its PT, which the server reads from the dictionary. The route reads only the list.
 */
export async function imeSeriousnessFor(target: ImeTarget): Promise<ImeSeriousnessPreview> {
  const client = await catalogApiClient(ImeSeriousnessControllerApi);
  if (target.kind === "llt") {
    return (await client.seriousness(undefined, target.lltCode, target.version, target.language)).data;
  }
  return (await client.seriousness(target.kind === "term" ? target.preferredTerm : undefined)).data;
}
